<div class="wrapper-content game-wrapper-full"
[class.color-1]="url=='incendios-forestales'"
[class.color-2]="url=='humedales'"
[style.background]="(url=='incendios-forestales')?'url('+'/assets/games/fuego-04.jpg'+')':'url('+'/assets/games/humedales-03.jpg'+')'">

  <div class="game-header fullwidth">
    <h5 class="legend">{{url}}</h5>
    <h1 class="title">Biblioteca Multimedia</h1>
    <a class="btn-back"   (click)="route.goTo('juego-inicio/'+url)" style="text-decoration: none;">
      <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
        <g id="Grupo_75" data-name="Grupo 75" transform="translate(-1142 -30)">
          <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)"/>
          <g id="Grupo_73" data-name="Grupo 73" transform="translate(1164.95 52.95)">
            <rect id="Rectángulo_3" data-name="Rectángulo 3" width="51" height="5.1" transform="translate(0 36.062) rotate(-45)" fill="#fff"/>
            <rect id="Rectángulo_141" data-name="Rectángulo 141" width="51" height="5.1" transform="translate(3.606 0) rotate(45)" fill="#fff"/>
          </g>
        </g>
      </svg>
    </a>
  </div>
  <div class="container-fluid game-content" style="padding-top: 30px;width:100%" *ngIf="blog">


    <div style="left: 15px;" class="wrapper-content col-12 wow fadeInUp" data-wow-delay="1s">
      <div class="wwf-box-min" *ngFor="let card of blog">
        <a class="wwf-card-min" href="{{
          (card.webcollection_id != '9' && card.webcollection_id != '10')?'recursos-formulario/'+card.id:card.link}}">
          <div class="wwf-card-min-thumb" role="img"
          [attr.aria-label]="card.altimage" [style.background]="'url('+api.getImageUrl(card.image)+')'"></div>
          <div class="wwf-card-min-body">
            <p class="min-title">{{card.title.es}}</p>
            <p class="min-tag ts-color-5">{{card.webcollection.title}} </p>
          <!--   <p class="min-tag">{{card.context.title}}</p> -->

          </div>
          <div class="wwf-card-min-btn ts-background-5">
            <svg *ngIf="card.webcollection_id != '9' && card.webcollection_id != '10'" xmlns="http://www.w3.org/2000/svg" width="31.429" height="40" viewBox="0 0 31.429 40">
              <g id="descarga" transform="translate(-80 -440)">
                <path id="Trazado_25" data-name="Trazado 25"
                  d="M97.143,451.429v13.158l5.714-5.715,2.021,2.021-9.164,9.163-9.163-9.163,2.02-2.021,5.715,5.715V451.429H81.071A1.071,1.071,0,0,0,80,452.5v26.429A1.072,1.072,0,0,0,81.071,480h29.286a1.072,1.072,0,0,0,1.072-1.071V452.5a1.071,1.071,0,0,0-1.072-1.071Z"
                  fill="#fff" />
                <rect id="Rectángulo_84" data-name="Rectángulo 84" width="2.857" height="11.429"
                  transform="translate(94.286 440)" fill="#fff" />
              </g>
            </svg>
            <svg *ngIf="card.webcollection_id == '9' || card.webcollection_id == '10'" id="Layer_1" style="width: 50%;" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><defs><style>.cls-1{fill:#fff;}</style></defs><title>icon-youtube</title><path class="cls-1" d="M35.29,45.36V32.69L47.84,39Z"/><path class="cls-1" d="M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0ZM63.15,49.6c-.63,3.79-2.54,5.57-6.38,5.71-8.72.31-17.45.36-26.18.47-2.24,0-4.5,0-6.74-.19-4.54-.31-6.63-1.9-7.07-6.41-.5-5.08-.44-10.22-.45-15.33a22.6,22.6,0,0,1,.8-5.4,5.73,5.73,0,0,1,5.59-4.67c5.9-.32,28.16-.33,33.38-.24,4.15.07,6.38,1.82,7.07,5.92A61,61,0,0,1,63.15,49.6Z"/></svg>
          </div>
        </a>
      </div>
    </div>

  </div>
</div>
